import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'Casino',
  to: '/casino'
}, {
  label: 'Restaurant',
  to: '/restaurant'
}, {
  label: 'Hotel',
  to: '/hotel'
}, {
  label: 'LKW Parken',
  to: '/lkw-parken'
}, {
  label: 'Tankstelle',
  to: '/tankstelle'
}, {
  label: 'Laden',
  to: '/ladesaeulen'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  return <>
      <motion.header className="fixed top-0 left-0 right-0 z-50 flex justify-center" initial={false} data-id="element-162">
        <motion.nav animate={{
        maxWidth: scrolled ? 820 : 10000,
        borderRadius: scrolled ? 9999 : 0,
        marginTop: scrolled ? 12 : 0,
        paddingLeft: scrolled ? 8 : 24,
        paddingRight: scrolled ? 8 : 24,
        backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0)',
        borderColor: scrolled ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0)',
        boxShadow: scrolled ? '0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5)' : '0 0 0 rgba(0, 0, 0, 0)'
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="w-full border backdrop-blur-2xl" style={{
        WebkitBackdropFilter: 'blur(40px)'
      }} data-id="element-163">
          <div className="flex items-center justify-between h-14 px-4" data-id="element-164">
            {/* Logo */}
            <Link to="/" className="shrink-0" data-id="element-165">
              <motion.span className={`font-heading font-bold text-lg tracking-tight transition-colors duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`} animate={{
              fontSize: scrolled ? '0.95rem' : '1.1rem'
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-166">
                Euro Rastpark
                <span className={`ml-1.5 hidden sm:inline transition-colors duration-300 ${scrolled ? 'text-gray-400' : 'text-white/40'}`} data-id="element-167">
                  Himmelkron
                </span>
              </motion.span>
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-1" data-id="element-168">
              {navLinks.map(link => {
              const isActive = location.pathname === link.to;
              return <Link key={link.to} to={link.to} className="relative px-3 py-1.5 text-sm font-medium transition-colors rounded-full" data-id="element-169">
                    {isActive && <motion.div layoutId="nav-active" className={`absolute inset-0 rounded-full ${scrolled ? 'bg-gray-900/10' : 'bg-white/10'}`} transition={{
                  type: 'spring',
                  stiffness: 400,
                  damping: 30
                }} data-id="element-170" />}
                    <span className={`relative z-10 transition-colors duration-300 ${scrolled ? isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-800' : isActive ? 'text-white' : 'text-white/60 hover:text-white/90'}`} data-id="element-171">
                      {link.label}
                    </span>
                  </Link>;
            })}
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileOpen(!mobileOpen)} className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-full transition-all ${scrolled ? 'text-gray-500 hover:text-gray-900 hover:bg-gray-200' : 'text-white/70 hover:text-white hover:bg-white/10'}`} aria-label="Menü" data-id="element-172">
              {mobileOpen ? <XIcon className="w-5 h-5" data-id="element-173" /> : <MenuIcon className="w-5 h-5" data-id="element-174" />}
            </button>
          </div>
        </motion.nav>
      </motion.header>

      {/* Mobile Overlay */}
      <AnimatePresence data-id="element-175">
        {mobileOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-40 bg-white/90 backdrop-blur-xl lg:hidden" style={{
        WebkitBackdropFilter: 'blur(20px)'
      }} data-id="element-176">
            <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3,
          delay: 0.05
        }} className="pt-24 px-6 flex flex-col gap-2" data-id="element-177">
              <Link to="/" className="text-2xl font-heading font-bold text-gray-400 hover:text-gray-900 py-3 transition-colors" data-id="element-178">
                Startseite
              </Link>
              {navLinks.map((link, i) => {
            const isActive = location.pathname === link.to;
            return <motion.div key={link.to} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.1 + i * 0.05
            }} data-id="element-179">
                    <Link to={link.to} className={`block text-2xl font-heading font-bold py-3 transition-colors ${isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-180">
                      {link.label}
                    </Link>
                  </motion.div>;
          })}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}